module.exports = __webpack_public_path__ + "img/20220310_151443.85471fab.jpg";